var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseStarsToBold = exports.hasStar = exports.replaceStars = void 0;
const react_1 = __importDefault(require("react"));
const any_1 = require("../elements/any");
const parse_new_lines_1 = require("./parse-new-lines");
exports.replaceStars = (children) => {
    const result = [];
    react_1.default.Children.forEach(children, (child) => {
        if (child && typeof child === 'string') {
            const findStar = child.split(/\*(.*)/);
            const hasStar = findStar.length > 1;
            if (!hasStar) {
                result.push(findStar[0]);
                return;
            }
            const findSecondStar = findStar[1].split(/\*(.*)/);
            const hasSecondStar = findSecondStar.length > 1;
            if (!hasSecondStar) {
                result.push(...findStar);
                return;
            }
            result.push(findStar[0], react_1.default.createElement("b", { key: findStar[0] }, findSecondStar[0]));
            const remaining = exports.replaceStars(findSecondStar[1]);
            result.push(...remaining);
        }
        else if (child) {
            result.push(child);
        }
    });
    return result;
};
exports.hasStar = (children) => {
    const childArray = react_1.default.Children.toArray(children);
    return (childArray &&
        Array.isArray(childArray) &&
        childArray.length > 0 &&
        typeof childArray[0] === 'string' &&
        childArray[0].indexOf('*') >= 0);
};
exports.ParseStarsToBold = (props) => {
    return (react_1.default.createElement(any_1.Any, { is: props.is, polyPreset: true, wheel: props.wheel }, exports.replaceStars(parse_new_lines_1.replaceNewlines(props.children))));
};
//# sourceMappingURL=parse-stars-to-bold.js.map